import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ProcessedReceiptsPanel.css';
import { formatDateShortRD } from '../utils/dateUtils';

const ProcessedReceiptsPanel = ({ isOpen, onClose, onSelectContact }) => {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      loadReceipts();
    }
  }, [isOpen]);

  const loadReceipts = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/receipts/processed');
      if (response.data.success) {
        setReceipts(response.data.receipts || []);
      }
    } catch (error) {
      console.error('Error cargando recibos procesados:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleContactClick = (contactId, phoneNumber) => {
    if (onSelectContact) {
      onSelectContact(contactId, phoneNumber);
      onClose();
    }
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return formatDateShortRD(date);
  };

  const getTypeLabel = (type) => {
    const labels = {
      transferencia: 'Transferencia',
      deposito: 'Depósito',
      sucursal: 'Subagente',
      cajero: 'Cajero'
    };
    return labels[type] || type;
  };

  if (!isOpen) return null;

  return (
    <div className="processed-receipts-overlay" onClick={onClose}>
      <div className="processed-receipts-panel" onClick={(e) => e.stopPropagation()}>
        <div className="processed-receipts-header">
          <h2>✅ Recibos Procesados Automáticamente</h2>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>

        <div className="processed-receipts-content">
          {loading ? (
            <div className="loading">Cargando recibos...</div>
          ) : receipts.length === 0 ? (
            <div className="empty-state">No hay recibos procesados automáticamente</div>
          ) : (
            <table className="processed-receipts-table">
              <thead>
                <tr>
                  <th>ID Cliente</th>
                  <th>Banco</th>
                  <th>Tipo</th>
                  <th>Fecha Transacción</th>
                  <th>No. Confirmación</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                {receipts.map(receipt => (
                  <tr key={receipt._id}>
                    <td>
                      {receipt.mikrowispId ? (
                        <button
                          className="client-id-link"
                          onClick={() => handleContactClick(receipt.contactId, receipt.phoneNumber)}
                          title="Abrir chat del cliente"
                        >
                          {receipt.mikrowispId}
                        </button>
                      ) : (
                        <span className="no-id">N/A</span>
                      )}
                    </td>
                    <td>{receipt.bank || 'N/A'}</td>
                    <td>{getTypeLabel(receipt.type)}</td>
                    <td>{formatDate(receipt.date)}</td>
                    <td>{receipt.confirmationNumber || 'N/A'}</td>
                    <td className="amount-cell">
                      {receipt.amount ? `$${receipt.amount.toFixed(2)}` : 'N/A'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessedReceiptsPanel;






